import * as actionTypes from './actionTypes';

export const fetchCartAbandonments = (timeThreshold = 24) => ({
  type: actionTypes.FETCH_CART_ABANDONMENTS_REQUEST,
  payload: { timeThreshold }
});

export const fetchCartAbandonmentsSuccess = (abandonments) => ({
  type: actionTypes.FETCH_CART_ABANDONMENTS_SUCCESS,
  payload: abandonments
});

export const fetchCartAbandonmentsFailure = (error) => ({
  type: actionTypes.FETCH_CART_ABANDONMENTS_FAILURE,
  payload: error
});

export const sendCartReminder = (payload) => ({
  type: actionTypes.SEND_CART_REMINDER_REQUEST,
  payload
});

export const sendCartReminderSuccess = (response) => ({
  type: actionTypes.SEND_CART_REMINDER_SUCCESS,
  payload: response
});

export const sendCartReminderFailure = (error) => ({
  type: actionTypes.SEND_CART_REMINDER_FAILURE,
  payload: error
});